// extracted by mini-css-extract-plugin
export var headerCell = "_55-1";
export var loadingStateCell = "_55-4";
export var rowWrapper = "_55-3";
export var standaloneTable = "_55-5";
export var table = "_55-0";
export var white = "_55-2";